import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';

import CONSTANTS from '../../../constants';
import viewHelper from '../../../helpers/view';

export default class SelectClass extends Component {

    onClassSelect(klass) {
        this.props.callbackToUpdateComponent({class: klass});
    }

    goBackToDate() {
        this.props.callbackToUpdateComponent({startDate: null, endDate: null, class: null});
    }

    renderClasses(classes) {
        let klassRows = [];
        let previousDate = '';
        _.each(classes, (klass) => {
            if(viewHelper.getFormattedDate(klass.start_date) === previousDate) {
                klassRows.push(this.getClassRow(klass))
            } else {
                klassRows.push(
                    <tr key={klass.start_date}>
                        <th>{moment(klass.start_date, CONSTANTS.DATE.FORMAT.DEFAULT).format('ddd MMMM DD, YYYY')}</th>
                        <th></th>
                        <th>Class</th>
                        <th>Instructor</th>
                    </tr>);
                klassRows.push(this.getClassRow(klass))
            }
            previousDate = viewHelper.getFormattedDate(klass.start_date)
        });
        return klassRows;
    }

    getClassRow(klass) {
        return (
            <tr key={klass.id}>
                <td>{viewHelper.getFormattedTime(klass.start_time)} - {viewHelper.getFormattedTime(klass.end_time)}</td>
                <td>{klass.signup ? <button className='btn btn-xs btn-primary' onClick={this.onClassSelect.bind(this, klass)}>Sign up {klass.max_members - klass.members_booked} Spots Left </button> : 'Booked' }</td>
                <td>{klass.activity_name}</td>
                <td>{klass.trainer_name}</td>
            </tr>
        )
    }

    renderClassesView(classes) {
        if (classes && classes.length > 0) {
            return (
                <div className='card-tile'>
                    <div className='card-header'><b>Classes</b></div>
                    <div className='card-body'>
                        <div className='table-responsive'>
                            <table className='table table-hover'>
                                <tbody>
                                {this.renderClasses(classes)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div>
                    <div className='text-bold'>
                        Sorry no classes for rest of the week from {viewHelper.getFormattedDate(this.props.startDate, CONSTANTS.DATE.FORMAT.DEFAULT)}.
                    </div>
                    <br />
                    <button className='btn btn-primary' onClick={this.goBackToDate.bind(this)}>Go Back</button>
                </div>
            )
        }
    }

    render () {
        return (
            <div className='col-xs-12 col-lg-12 col-md-12'>
                <h4>Class Availability For {this.props.activity.description} From {viewHelper.getFormattedDate(this.props.startDate, CONSTANTS.DATE.FORMAT.DEFAULT)} - {viewHelper.getFormattedDate(this.props.endDate, CONSTANTS.DATE.FORMAT.DEFAULT)} </h4>
                {this.renderClassesView(this.props.classes)}
            </div>
        );
    }
}
